import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { IClient, QueryClient } from './Client.service';
import { IYard } from './Yard.service';

export interface IHarbor {
	id?: number;
	name: string;
	isActive: boolean;
	address?: string;
	client?: Partial<IClient>;
	yards: IYard[];
	actions?: any;
}

abstract class HarborService {
	static async getAll(
		params?: QueryClient
	): Promise<PaginationContent<IHarbor> | undefined> {
		let isActive;
		if (params?.isActive && Number(params.isActive) > -1) {
			isActive = params.isActive;
		}

		try {
			const response: PaginationContent<IHarbor> = await request(
				'/harbors',
				'get',
				{
					params: { ...params, isActive },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		data: IHarbor,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'post');
	}

	static async edit(
		data: IHarbor,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'patch');
	}

	private static async createOrEdit(
		content: IHarbor,
		setError: React.Dispatch<React.SetStateAction<string>>,
		mode: 'post' | 'patch'
	) {
		try {
			const { id, client, yards, ...data } = content;
			const url = mode === 'post' ? '/harbors' : `/harbors/${id}`;
			const response = await request(url, mode, {
				data: { ...data, id_cliente: Number(client?.id) },
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}
}

export default HarborService;
